export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Automotive technicians, mechanics, EV technicians, hybrid technicians and automotive professionals.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. EV & HYBRID DIAGNOSTIC PRO™ is a 100% digital resource.',
  },
  {
    question: 'Is this a training course or certification?',
    answer:
      'No. It is a practical professional diagnostic reference and troubleshooting system.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. It focuses on visual system references, diagnostic workflows, troubleshooting paths, scan-data guidance and practical tools.',
  },
  {
    question: 'What areas are included?',
    answer:
      'EV and hybrid systems, battery/BMS, motor/inverter, charging, thermal management and fault finding.',
  },
  {
    question: 'Does this replace professional procedures or manufacturer instructions?',
    answer:
      'No. Always follow manufacturer documentation, high-voltage safety procedures and applicable workplace requirements.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
  {
    question: 'Is it manufacturer-specific?',
    answer:
      'No. The system is manufacturer-neutral. It explains EV and hybrid systems, symptoms and diagnostic relationships that apply across brands, while OEM documentation governs all testing and specifications.',
  },
  {
    question: 'Can I use it on a phone or tablet in the workshop?',
    answer:
      'Yes. It is a digital resource you can open on a phone, tablet, laptop or workshop computer, or print the references and worksheets you use most.',
  },
  {
    question: 'What if it is not right for me?',
    answer:
      'You have a 7-day money-back guarantee. Contact us within 7 days for a full refund according to the refund terms.',
  },
]
